"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNodeTypeKey = void 0;
const constants_1 = require("./constants");
function isNodeTypeKey(value) {
    return !!Object.values(constants_1.NodeTypeMap).find((v) => String(v) === value);
}
exports.isNodeTypeKey = isNodeTypeKey;
